export const API_HOST = `${location.protocol}//${location.hostname}${location.port ? `:${location.port}` : ''}`;
export const API_HOST_DIAG = `${location.protocol}//${location.hostname}${location.port ? `:${location.port}` : ''}/api`;
export const API_HOST_DIAG_CART = `${location.protocol}//${location.hostname}${location.port ? `:${location.port}` : ''}/diagnostics/api`;
export const API_HOST_ALLOY = `${location.protocol}//${location.hostname}${location.port ? `:${location.port}` : ''}/alloy`;
export const API_HOST_ALLOY_SEARCH = `${location.protocol}//${location.hostname}${location.port ? `:${location.port}` : ''}/alloy_search`;
export const API_PORT = 80;
export const IMAGE_URL_PREFIX = `https://assets.pharmeasy.in/web-assets/images/`;
export const SLOT_DISPLAY_CLAMP = 9; // max slots shown before "View More"
export const CMS_URL_SUBSCRIPTION = 'http://cms.pharmeasy.in/subscription/view';
export const CMS_URL = 'http://cms.pharmeasy.in';

// Route paths
export const ROUTE_PATHS = {
  CUSTOMER_INFO: '/customer-info',
  SERVICE_SELECT_PACKAGE: (serviceType) => `/services/${serviceType}/select-package`,
  SERVICE_SLOT_PATIENT: (serviceType) => `/services/${serviceType}/slot-patient`,
  DOC_CONSULT_SELECT_DOCTOR: '/doc-consult/select-doctor',
};
export const ORDER_TYPE_DIAGNOSTIC = 'ORDER_TYPE_DIAGNOSTIC';
export const ORDER_TYPE_MEDICINE = 'ORDER_TYPE_MEDICINE';
export const ORDER_TYPE_DOC_CONSULT = 'ORDER_TYPE_DOC_CONSULT';

export const FETCH_SPECIALITIES = 'FETCH_SPECIALITIES';
export const FETCH_SPECIALITIES_START = 'FETCH_SPECIALITIES_START';
export const FETCH_SPECIALITIES_SUCCESS = 'FETCH_SPECIALITIES_SUCCESS';
export const FETCH_SPECIALITIES_FAILURE = 'FETCH_SPECIALITIES_FAILURE';
export const SET_SELECTED_SPECIALITY = 'SET_SELECTED_SPECIALITY';

export const FETCH_DOCTORS = 'FETCH_DOCTORS';
export const FETCH_DOCTORS_START = 'FETCH_DOCTORS_START';
export const FETCH_DOCTORS_SUCCESS = 'FETCH_DOCTORS_SUCCESS';
export const FETCH_DOCTORS_FAILURE = 'FETCH_DOCTORS_FAILURE';
export const SET_SELECTED_DOCTOR = 'SET_SELECTED_DOCTOR';

export const FETCH_SLOTS = 'FETCH_SLOTS';
export const FETCH_SLOTS_START = 'FETCH_SLOTS_START';
export const FETCH_SLOTS_SUCCESS = 'FETCH_SLOTS_SUCCESS';
export const FETCH_SLOTS_FAILURE = 'FETCH_SLOTS_FAILURE';
export const SET_SELECTED_DATE = 'SET_SELECTED_DATE';
export const SET_DOC_CONSULT_SLOT = 'SET_DOC_CONSULT_SLOT';
export const SET_PATIENT_DETAILS = 'SET_PATIENT_DETAILS';
export const SET_CONSULT_MODE = 'SET_CONSULT_MODE';
export const SET_SYMPTOMS = 'SET_SYMPTOMS';
export const SET_DOC_CONSULT_APPLIED_PROMO = 'SET_DOC_CONSULT_APPLIED_PROMO';
export const FETCH_DOC_CONSULT_BIFURCATION = 'FETCH_DOC_CONSULT_BIFURCATION';
export const FETCH_DOC_CONSULT_BIFURCATION_START = 'FETCH_DOC_CONSULT_BIFURCATION_START';
export const FETCH_DOC_CONSULT_BIFURCATION_SUCCESS = 'FETCH_DOC_CONSULT_BIFURCATION_SUCCESS';
export const FETCH_DOC_CONSULT_BIFURCATION_FAILURE = 'FETCH_DOC_CONSULT_BIFURCATION_FAILURE';
export const CREATE_DOC_CONSULT_ORDER = 'CREATE_DOC_CONSULT_ORDER';
export const CREATE_DOC_CONSULT_ORDER_START = 'CREATE_DOC_CONSULT_ORDER_START';
export const CREATE_DOC_CONSULT_ORDER_SUCCESS = 'CREATE_DOC_CONSULT_ORDER_SUCCESS';
export const CREATE_DOC_CONSULT_ORDER_FAILURE = 'CREATE_DOC_CONSULT_ORDER_FAILURE';

export const AGENT_LOGIN = 'AGENT_LOGIN';
export const AGENT_LOGIN_START = 'AGENT_LOGIN_START';
export const AGENT_LOGIN_SUCCESS = 'AGENT_LOGIN_SUCCESS';
export const AGENT_LOGIN_FAILURE = 'AGENT_LOGIN_FAILURE';

export const LOCAL_LOGIN = 'LOCAL_LOGIN';

export const SSO_LOGIN = 'SSO_LOGIN';
export const SSO_LOGIN_START = 'SSO_LOGIN_START';
export const SSO_LOGIN_SUCCESS = 'SSO_LOGIN_SUCCESS';
export const SSO_LOGIN_FAILURE = 'SSO_LOGIN_FAILURE';

export const CUSTOMER_SEARCH = 'CUSTOMER_SEARCH';
export const CUSTOMER_SEARCH_START = 'CUSTOMER_SEARCH_START';
export const CUSTOMER_SEARCH_SUCCESS = 'CUSTOMER_SEARCH_SUCCESS';
export const CUSTOMER_SEARCH_FAILURE = 'CUSTOMER_SEARCH_FAILURE';
export const CUSTOMER_SURVEY_INITIATED = 'CUSTOMER_SURVEY_INITIATED';
export const MEDLIFE_LEAD_HOST = {
  production: 'https://leads-labs.medlife.com',
  development: 'https://preprod-leads-labs.medlife.com',
  staging: 'https://preprod-leads-labs.medlife.com'
};
// Medlife Related
export const MEDLIFE_LEAD_X_CODE = {
  production: '32ddb1e1869760828g7cc4c7680ecg1e',
  development: '32ddb1e1869760828g7cc4c7680ecg1e',
  staging: '32ddb1e1869760828g7cc4c7680ecg1e'
};

/** GTM Related */
export const GTM_CONTAINER_ENV_MAP = {
  production: 'GTM-WLNQ3VJ',
  development: 'GTM-PBFVT5M',
  staging: 'GTM-PBFVT5M',
};

export const CHANNEL_PARAM = "ooc";

export const availabilityLevelEnum = Object.freeze({
  GREEN: 1,
  YELLOW: 2,
  RED: 3,
})
/** Use
 if (availabilityLevelEnum.RED == item.availabilityLevel) {
    console.log('THIS IS A RED ITEM');
  }
*/

export const RECOMMENDATION_SOURCE = 'p_ooc_cart';
export const OOC_SOURCE = 'order-on-call';

export const ITEM_TYPE_OTC = 'otc';

// Event Constants
export const ELEMENT_TYPE_RECOMMENDATION = 'recommendation';
export const ELEMENT_SCROLL_TYPE_HORIZONTAL = 'horizontal';
export const ELEMENT_CLICKED = 'element_clicked';
export const RECOMMENDATION_BUTTON_CLICKED = 'i_recommendations_button_clicked';
export const RECOMMENDATION_INFO_CLICKED = 'i_recommendations_info_clicked';
export const RECOMMENDATION_COULD_NOT_SUGGEST = 'i_could_not_suggest_clicked';
export const RECOMMENDATION_CUSTOMER_NOT_INTERESTED_CLICKED = 'i_recommendations_customer_not_interested_clicked';
export const RECOMMENDATION_NAME_CLICKED = 'i_recommendations_name_clicked';
export const CUSTOMER_SEARCH_EVENT = 'i_customer_searched';
export const ELEMENT_VIEWED = 'i_element_viewed';
export const ADD_TO_CART_EVENT = 'c_add_to_cart';
export const MAKE_OTP_SEND_CHOICE = 'l_otp_login';
export const OTP_INPUT_LOAD = 'p_otp';
export const OTP_STATUS = 'i_otp_status_ooc';
export const RESEND_OTP_CLICK = 'i_resend_otp';

// InView Constants
export const ON_PAGE_LOAD = 'on_page_load';
export const ON_PAGE_SCROLL = 'on_scroll';

/** START: Susbtitution Constants */
export const LOG_TYPE_SUBSTITUTES_AVAILABLE = 1;
export const LOG_TYPE_SUBSTITUTES_VIEWED = 2;
export const LOG_TYPE_SUBSTITUTE_SELECTED = 3;
export const LOG_TYPE_SUBSTITUTE_ADDED_TO_CART = 4;
export const LOG_TYPE_SUBSTITUTE_ADDED_TO_ORDER = 5;
export const TYPE_SUBSTITUTE = 1;
export const TYPE_VARIANT = 2;
export const TYPE_SIMILAR_PRODUCT = 3;
export const REASON_TYPE_CONVERTED = 1;
export const REASON_TYPE_NOT_CONVERTED = 2;

/** END: Susbtitution Constants */


export const SET_ORDER_TYPE = 'SET_ORDER_TYPE';

export const SET_CUSTOMER_LEAD = 'SET_CUSTOMER_LEAD';
export const SET_SF_LEAD = 'SET_SF_LEAD';

export const CLOSE_LEAD = 'CLOSE_LEAD';
export const CLOSE_LEAD_START = 'CLOSE_LEAD_START';
export const CLOSE_LEAD_SUCCESS = 'CLOSE_LEAD_SUCCESS';
export const CLOSE_LEAD_FAILURE = 'CLOSE_LEAD_FAILURE';

export const PINCODE_DELIVERABLE = 'PINCODE_DELIVERABLE';
export const PINCODE_DELIVERABLE_START = 'PINCODE_DELIVERABLE_START';
export const PINCODE_DELIVERABLE_SUCCESS = 'PINCODE_DELIVERABLE_SUCCESS';
export const PINCODE_DELIVERABLE_FAILURE = 'PINCODE_DELIVERABLE_FAILURE';

export const PRODUCT_SEARCH = 'PRODUCT_SEARCH';
export const PRODUCT_SEARCH_START = 'PRODUCT_SEARCH_START';
export const PRODUCT_SEARCH_SUCCESS = 'PRODUCT_SEARCH_SUCCESS';
export const PRODUCT_SEARCH_FAILURE = 'PRODUCT_SEARCH_FAILURE';
export const PRODUCT_SEARCH_CLEAR = 'PRODUCT_SEARCH_CLEAR';

export const PRODUCT_SEARCH_DIAG = 'PRODUCT_SEARCH_DIAG';
export const PRODUCT_SEARCH_DIAG_START = 'PRODUCT_SEARCH_DIAG_START';
export const PRODUCT_SEARCH_DIAG_SUCCESS = 'PRODUCT_SEARCH_DIAG_SUCCESS';
export const PRODUCT_SEARCH_DIAG_FAILURE = 'PRODUCT_SEARCH_DIAG_FAILURE';


export const ADD_PRODUCTS = 'ADD_PRODUCTS';
export const CUSTOMER_INFO = 'CUSTOMER_INFO';
export const SELECT_ADDRESS = 'SELECT_ADDRESS';
export const SET_RX_AVAILABILITY = 'SET_RX_AVAILABILITY';

export const DOC_CONSULT_SEARCH = 'DOC_CONSULT_SEARCH';
export const DOC_CONSULT_SELECT_DOCTOR = 'DOC_CONSULT_SELECT_DOCTOR';
export const DOC_CONSULT_SLOT_PATIENT = 'DOC_CONSULT_SLOT_PATIENT';
export const SERVICE_PLATFORM_SELECT_PACKAGE = 'SERVICE_PLATFORM_SELECT_PACKAGE';
export const SERVICE_PLATFORM_SLOT_PATIENT = 'SERVICE_PLATFORM_SLOT_PATIENT';
export const RESET_SERVICE_PLATFORM = 'RESET_SERVICE_PLATFORM';
export const SET_RX_AVAILABILITY_STATE = 'SET_RX_AVAILABILITY_STATE';

// SERVICE-PLATFORM CONSTANTS - FOR ALL PLATFORMS

// Service metadata
export const SET_SERVICE_DETAILS = 'SET_SERVICE_DETAILS';

// Categories (to fetch all the cards in all categories)
export const FETCH_CATEGORIES_SUBCATEGORIES = 'FETCH_CATEGORIES_SUBCATEGORIES';
export const FETCH_CATEGORIES_SUBCATEGORIES_START = 'FETCH_CATEGORIES_SUBCATEGORIES_START';
export const FETCH_CATEGORIES_SUBCATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUBCATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_SUBCATEGORIES_FAILURE = 'FETCH_CATEGORIES_SUBCATEGORIES_FAILURE';

// Item details (for vendor info)
export const FETCH_SERVICE_ITEM_DETAILS = 'FETCH_SERVICE_ITEM_DETAILS';
export const FETCH_SERVICE_ITEM_DETAILS_START = 'FETCH_SERVICE_ITEM_DETAILS_START';
export const FETCH_SERVICE_ITEM_DETAILS_SUCCESS = 'FETCH_SERVICE_ITEM_DETAILS_SUCCESS';
export const FETCH_SERVICE_ITEM_DETAILS_FAILURE = 'FETCH_SERVICE_ITEM_DETAILS_FAILURE';

// Package selection
export const FETCH_SERVICE_PACKAGES = 'FETCH_SERVICE_PACKAGES';
export const FETCH_SERVICE_PACKAGES_START = 'FETCH_SERVICE_PACKAGES_START';
export const FETCH_SERVICE_PACKAGES_SUCCESS = 'FETCH_SERVICE_PACKAGES_SUCCESS';
export const FETCH_SERVICE_PACKAGES_FAILURE = 'FETCH_SERVICE_PACKAGES_FAILURE';
export const SET_SELECTED_SERVICE_PACKAGE = 'SET_SELECTED_SERVICE_PACKAGE';

// Batch package loading
export const FETCH_SERVICE_PACKAGES_BATCH_START = 'FETCH_SERVICE_PACKAGES_BATCH_START';
export const FETCH_SERVICE_PACKAGES_BATCH_ITEM = 'FETCH_SERVICE_PACKAGES_BATCH_ITEM';
export const FETCH_SERVICE_PACKAGES_BATCH_ITEM_START = 'FETCH_SERVICE_PACKAGES_BATCH_ITEM_START';
export const FETCH_SERVICE_PACKAGES_BATCH_ITEM_SUCCESS = 'FETCH_SERVICE_PACKAGES_BATCH_ITEM_SUCCESS';
export const FETCH_SERVICE_PACKAGES_BATCH_ITEM_FAILURE = 'FETCH_SERVICE_PACKAGES_BATCH_ITEM_FAILURE';

// Slot selection
export const FETCH_SERVICE_SLOTS = 'FETCH_SERVICE_SLOTS';
export const FETCH_SERVICE_SLOTS_START = 'FETCH_SERVICE_SLOTS_START';
export const FETCH_SERVICE_SLOTS_SUCCESS = 'FETCH_SERVICE_SLOTS_SUCCESS';
export const FETCH_SERVICE_SLOTS_FAILURE = 'FETCH_SERVICE_SLOTS_FAILURE';
export const SET_SELECTED_SERVICE_DATE = 'SET_SELECTED_SERVICE_DATE';
export const SET_SELECTED_SERVICE_SLOT = 'SET_SELECTED_SERVICE_SLOT';
export const SET_SELECTED_SERVICE_FILTER = 'SET_SELECTED_SERVICE_FILTER';

// Bifurcation
export const FETCH_SERVICE_BIFURCATION = 'FETCH_SERVICE_BIFURCATION';
export const FETCH_SERVICE_BIFURCATION_START = 'FETCH_SERVICE_BIFURCATION_START';
export const FETCH_SERVICE_BIFURCATION_SUCCESS = 'FETCH_SERVICE_BIFURCATION_SUCCESS';
export const FETCH_SERVICE_BIFURCATION_FAILURE = 'FETCH_SERVICE_BIFURCATION_FAILURE';

// Order creation
export const FETCH_SERVICE_ITEM_VARIANTS = 'FETCH_SERVICE_ITEM_VARIANTS';
export const FETCH_SERVICE_ITEM_VARIANTS_START = 'FETCH_SERVICE_ITEM_VARIANTS_START';
export const FETCH_SERVICE_ITEM_VARIANTS_SUCCESS = 'FETCH_SERVICE_ITEM_VARIANTS_SUCCESS';
export const FETCH_SERVICE_ITEM_VARIANTS_FAILURE = 'FETCH_SERVICE_ITEM_VARIANTS_FAILURE';

export const CREATE_SERVICE_ORDER = 'CREATE_SERVICE_ORDER';
export const CREATE_SERVICE_ORDER_START = 'CREATE_SERVICE_ORDER_START';
export const CREATE_SERVICE_ORDER_SUCCESS = 'CREATE_SERVICE_ORDER_SUCCESS';
export const CREATE_SERVICE_ORDER_FAILURE = 'CREATE_SERVICE_ORDER_FAILURE';

// Page navigation
export const SERVICE_PACKAGE_SEARCH = 'SERVICE_PACKAGE_SEARCH';
export const SERVICE_SLOT_PATIENT = 'SERVICE_SLOT_PATIENT';

export const GET_CART = 'GET_CART';
export const GET_CART_START = 'GET_CART_START';
export const GET_CART_SUCCESS = 'GET_CART_SUCCESS';
export const GET_CART_FAILURE = 'GET_CART_FAILURE';

export const UPDATE_CART = 'UPDATE_CART';
export const UPDATE_CART_START = 'UPDATE_CART_START';
export const UPDATE_CART_SUCCESS = 'UPDATE_CART_SUCCESS';
export const UPDATE_CART_FAILURE = 'UPDATE_CART_FAILURE';

export const ADD_TO_CART = 'ADD_TO_CART';
export const ADD_TO_CART_START = 'ADD_TO_CART_START';
export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_FAILURE = 'ADD_TO_CART_FAILURE';

export const NOTIY_CUSTOMER_DTP = 'NOTIY_CUSTOMER_DTP';

export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const REMOVE_FROM_CART_START = 'REMOVE_FROM_CART_START';
export const REMOVE_FROM_CART_SUCCESS = 'REMOVE_FROM_CART_SUCCESS';
export const REMOVE_FROM_CART_FAILURE = 'REMOVE_FROM_CART_FAILURE';

export const GET_CART_V5 = 'GET_CART_V5';
export const GET_CART_V5_START = 'GET_CART_V5_START';
export const GET_CART_V5_SUCCESS = 'GET_CART_V5_SUCCESS';
export const GET_CART_V5_FAILURE = 'GET_CART_V5_FAILURE';

export const GET_LOYALTY_DATA = 'GET_LOYALTY_DATA';
export const GET_LOYALTY_DATA_START = 'GET_LOYALTY_DATA_START';
export const GET_LOYALTY_DATA_SUCCESS = 'GET_LOYALTY_DATA_SUCCESS';
export const GET_LOYALTY_DATA_FAILURE = 'GET_LOYALTY_DATA_FAILURE';


export const RESET_LOYALTY_DATA = 'RESET_LOYALTY_DATA';

export const SELECT_VARIANT = 'SELECT_VARIANT';
export const RESET_SELECTED_VARIANT_DATA = 'RESET_SELECTED_VARIANT_DATA';


export const GET_ACTIVE_REFILLS = 'GET_ACTIVE_REFILLS';
export const GET_ACTIVE_REFILLS_START = 'GET_ACTIVE_REFILLS_START';
export const GET_ACTIVE_REFILLS_SUCCESS = 'GET_ACTIVE_REFILLS_SUCCESS';
export const GET_ACTIVE_REFILLS_FAILURE = 'GET_ACTIVE_REFILLS_FAILURE';

export const GET_DELIVERY_PREFERENCES = 'GET_DELIVERY_PREFERENCES';
export const GET_DELIVERY_PREFERENCES_START = 'GET_DELIVERY_PREFERENCES_START';
export const GET_DELIVERY_PREFERENCES_SUCCESS = 'GET_DELIVERY_PREFERENCES_SUCCESS';
export const GET_DELIVERY_PREFERENCES_FAILURE = 'GET_DELIVERY_PREFERENCES_FAILURE';

export const GET_CART_AMOUNT_BIFURCATION = 'GET_CART_AMOUNT_BIFURCATION';
export const GET_CART_AMOUNT_BIFURCATION_START = 'GET_CART_AMOUNT_BIFURCATION_START';
export const GET_CART_AMOUNT_BIFURCATION_SUCCESS = 'GET_CART_AMOUNT_BIFURCATION_SUCCESS';
export const GET_CART_AMOUNT_BIFURCATION_FAILURE = 'GET_CART_AMOUNT_BIFURCATION_FAILURE';

export const CHANGE_SHIPMENT_PREFERENCE = 'CHANGE_SHIPMENT_PREFERENCE';

export const PINCODE_SERVICEABLE = 'PINCODE_SERVICEABLE';
export const PINCODE_SERVICEABLE_START = 'PINCODE_SERVICEABLE_START';
export const PINCODE_SERVICEABLE_SUCCESS = 'PINCODE_SERVICEABLE_SUCCESS';
export const PINCODE_SERVICEABLE_FAILURE = 'PINCODE_SERVICEABLE_FAILURE';

// Address constants
export const FETCH_ADDRESSES = 'FETCH_ADDRESSES';
export const FETCH_ADDRESSES_START = 'FETCH_ADDRESSES_START';
export const FETCH_ADDRESSES_SUCCESS = 'FETCH_ADDRESSES_SUCCESS';
export const FETCH_ADDRESSES_FAILURE = 'FETCH_ADDRESSES_FAILURE';

export const DELETE_ADDRESS = 'DELETE_ADDRESS';
export const DELETE_ADDRESS_START = 'DELETE_ADDRESS_START';
export const DELETE_ADDRESS_SUCCESS = 'DELETE_ADDRESS_SUCCESS';
export const DELETE_ADDRESS_FAILURE = 'DELETE_ADDRESS_FAILURE';

export const EDIT_ADDRESS = 'EDIT_ADDRESS';
export const EDIT_ADDRESS_START = 'EDIT_ADDRESS_START';
export const EDIT_ADDRESS_SUCCESS = 'EDIT_ADDRESS_SUCCESS';
export const EDIT_ADDRESS_FAILURE = 'EDIT_ADDRESS_FAILURE';

export const ADD_ADDRESS = 'ADD_ADDRESS';
export const ADD_ADDRESS_START = 'ADD_ADDRESS_START';
export const ADD_ADDRESS_SUCCESS = 'ADD_ADDRESS_SUCCESS';
export const ADD_ADDRESS_FAILURE = 'ADD_ADDRESS_FAILURE';

export const SELECT_ADDRESS_SUCCESS = 'SELECT_ADDRESS_SUCCESS';
export const SELECT_PATIENT_SUCCESS = 'SELECT_PATIENT_SUCCESS';
export const SELECT_ADDRESS_DIAGNOSTICS_SUCCESS = 'SELECT_ADDRESS_DIAGNOSTICS_SUCCESS';

export const LOAD_LAB_SERVICEABILITY = 'LOAD_LAB_SERVICEABILITY';
export const LOAD_LAB_SERVICEABILITY_START = 'LOAD_LAB_SERVICEABILITY_START';
export const LOAD_LAB_SERVICEABILITY_SUCCESS = 'LOAD_LAB_SERVICEABILITY_SUCCESS';
export const LOAD_LAB_SERVICEABILITY_FAIL = 'LOAD_LAB_SERVICEABILITY_FAIL';

export const SET_ORDER_PARAMS = 'SET_ORDER_PARAMS';


export const HOTKEYS_PRESS = 'HOTKEYS_PRESS';
export const AGENT_LOGOUT = 'AGENT_LOGOUT';
export const AGENT_LOGOUT_START = 'AGENT_LOGOUT_START';
export const AGENT_LOGOUT_SUCCESS = 'AGENT_LOGOUT_SUCCESS';
export const AGENT_LOGOUT_FAILURE = 'AGENT_LOGOUT_FAILURE';
export const CLOSE_POPUP = 'CLOSE_POPUP';
export const OPEN_HELP_POPUP = 'OPEN_HELP_POPUP';
export const CLOSE_THIS_TASK = 'CLOSE_THIS_TASK';
export const MOVE_FORWARD = 'MOVE_FORWARD';
export const MOVE_BACKWARD = 'MOVE_BACKWARD';
export const HOTKEYS_START = 'HOTKEYS_START';
export const MEDICINE_SEARCH = 'MEDICINE_SEARCH';
export const UP_ARROW = 'UP_ARROW';
export const DOWN_ARROW = 'DOWN_ARROW';
export const LEFT_ARROW = 'LEFT_ARROW';
export const RIGHT_ARROW = 'RIGHT_ARROW';
export const RETURN = 'RETURN ';
export const PLUS = 'PLUS';
export const MINUS = 'MINUS';
export const OPEN_CMS_URL_SUBSCRIPTION = 'OPEN_CMS_URL_SUBSCRIPTION';
export const TAB_MOVE_LEFT = 'TAB_MOVE_LEFT';


export const DISCOUNT_COUPON = 'DISCOUNT_COUPON';
export const PLACE_ORDER = 'PLACE_ORDER';
export const SELECT_PRESCRIPTIONS = 'SELECT_PRESCRIPTIONS';
export const ADD_NEW_ADDRESS = 'ADD_NEW_ADDRESS';
export const TAB_MOVE_RIGHT = 'TAB_MOVE_RIGHT';
export const APPLY_COUPON = 'APPLY_COUPON';
export const CHANGE_SEARCH_TEXT = 'CHANGE_SEARCH_TEXT';


export const CANCEL_ORDER = 'CANCEL_ORDER';

// promocode
export const SET_PROMOCODE = 'SET_PROMOCODE';
export const SET_PROMOCODE_START = 'SET_PROMOCODE_START';
export const SET_PROMOCODE_SUCCESS = 'SET_PROMOCODE_SUCCESS';
export const SET_PROMOCODE_FAILURE = 'SET_PROMOCODE_FAILURE';
export const RESET_PROMOCODE = 'RESET_PROMOCODE';

export const SET_DIAGNOSTICS_PROMOCODE = 'SET_DIAGNOSTICS_PROMOCODE';
export const SET_DIAGNOSTICS_PROMOCODE_START = 'SET_DIAGNOSTICS_PROMOCODE_START';
export const SET_DIAGNOSTICS_PROMOCODE_SUCCESS = 'SET_DIAGNOSTICS_PROMOCODE_SUCCESS';
export const SET_DIAGNOSTICS_PROMOCODE_FAILURE = 'SET_DIAGNOSTICS_PROMOCODE_FAILURE';
export const RESET_DIAGNOSTICS_PROMOCODE = 'RESET_DIAGNOSTICS_PROMOCODE';

export const CREATE_ORDER = 'CREATE_ORDER';
export const CREATE_ORDER_START = 'CREATE_ORDER_START';
export const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS';
export const CREATE_ORDER_FAILURE = 'CREATE_ORDER_FAILURE';

export const FETCH_ORDER = 'FETCH_ORDER';
export const FETCH_ORDER_START = 'FETCH_ORDER_START';
export const FETCH_ORDER_SUCCESS = 'FETCH_ORDER_SUCCESS';
export const FETCH_ORDER_FAILURE = 'FETCH_ORDER_FAILURE';

export const FETCH_ACTIVE_REFILL = 'FETCH_ACTIVE_REFILL';
export const FETCH_ACTIVE_REFILL_START = 'FETCH_ACTIVE_REFILL_START';
export const FETCH_ACTIVE_REFILL_SUCCESS = 'FETCH_ACTIVE_REFILL_SUCCESS';
export const FETCH_ACTIVE_REFILL_FAILURE = 'FETCH_ACTIVE_REFILL_FAILURE';

export const FETCH_PRODUCT_ALTERNATES = 'FETCH_PRODUCT_ALTERNATES';
export const FETCH_SIMILAR_PRODUCTS = 'FETCH_SIMILAR_PRODUCTS';

export const ADD_CART_SUBSTITUTION_RECORD = 'ADD_CART_SUBSTITUTION_RECORD';
export const ADD_SUBSTITUTION_EVENT_LOG = 'ADD_SUBSTITUTION_EVENT_LOG';

export const FETCH_CART_SUBSTITUTIONS = 'FETCH_CART_SUBSTITUTIONS';
export const FETCH_CART_SUBSTITUTIONS_SUCCESS = 'FETCH_CART_SUBSTITUTIONS_SUCCESS';

export const FETCH_SUBSTITUTION_REASONS = 'FETCH_SUBSTITUTION_REASONS';
export const SAVE_SUBSTITUTION_REASONS = 'SAVE_SUBSTITUTION_REASONS';
export const POST_SUBSTITUTION_REASONS = 'POST_SUBSTITUTION_REASONS';
export const SET_SESSION_ORDER_MAP = 'SET_SESSION_ORDER_MAP';

export const FETCH_DELIVERED_MEDICINES = 'FETCH_DELIVERED_MEDICINES';
export const FETCH_DELIVERED_MEDICINES_START = 'FETCH_DELIVERED_MEDICINES_START';
export const FETCH_DELIVERED_MEDICINES_SUCCESS = 'FETCH_DELIVERED_MEDICINES_SUCCESS';
export const FETCH_DELIVERED_MEDICINES_FAILURE = 'FETCH_DELIVERED_MEDICINES_FAILURE';

export const FETCH_DELIVERED_ORDERS = 'FETCH_DELIVERED_ORDERS';
export const FETCH_DELIVERED_ORDERS_START = 'FETCH_DELIVERED_ORDERS_START';
export const FETCH_DELIVERED_ORDERS_SUCCESS = 'FETCH_DELIVERED_ORDERS_SUCCESS';
export const FETCH_DELIVERED_ORDERS_FAILURE = 'FETCH_DELIVERED_ORDERS_FAILURE';

export const CUSTOMER_PROFILE_UPDATE = 'CUSTOMER_PROFILE_UPDATE';
export const CUSTOMER_PROFILE_UPDATE_START = 'CUSTOMER_PROFILE_UPDATE_START';
export const CUSTOMER_PROFILE_UPDATE_SUCCESS = 'CUSTOMER_PROFILE_UPDATE_SUCCESS';
export const CUSTOMER_PROFILE_UPDATE_FAILURE = 'CUSTOMER_PROFILE_UPDATE_FAILURE';

export const GET_PAYMENT_GATEWAYS = 'GET_PAYMENT_GATEWAYS';
export const GET_PAYMENT_GATEWAYS_START = 'GET_PAYMENT_GATEWAYS_START';
export const GET_PAYMENT_GATEWAYS_SUCCESS = 'GET_PAYMENT_GATEWAYS_SUCCESS';
export const GET_PAYMENT_GATEWAYS_FAILURE = 'GET_PAYMENT_GATEWAYS_FAILURE';

export const FETCH_PAYMENT_METHODS = 'FETCH_PAYMENT_METHODS';

export const FETCH_WALLET_DETAILS = 'FETCH_WALLET_DETAILS';

export const GET_PRESCRIPTION_IMAGES = 'GET_PRESCRIPTION_IMAGES';
export const GET_PRESCRIPTION_IMAGES_START = 'GET_PRESCRIPTION_IMAGES_START';
export const GET_PRESCRIPTION_IMAGES_SUCCESS = 'GET_PRESCRIPTION_IMAGES_SUCCESS';
export const GET_PRESCRIPTION_IMAGES_FAILURE = 'GET_PRESCRIPTION_IMAGES_FAILURE';

export const SAVE_NEW_PRESCRIPTION = 'SAVE_NEW_PRESCRIPTION';
export const DELETE_NEW_PRESCRIPTION = 'DELETE_NEW_PRESCRIPTION';

export const GET_S3_UPLOAD_URL = 'GET_S3_UPLOAD_URL';
export const GET_S3_UPLOAD_URL_SUCCESS = 'GET_S3_UPLOAD_URL_SUCCESS';
export const GET_S3_UPLOAD_URL_FAILURE = 'GET_S3_UPLOAD_URL_FAILURE';

export const SEARCH_NEIGHBOURHOOD = 'SEARCH_NEIGHBOURHOOD';
export const SET_CUSTOMER_PINCODE = 'SET_CUSTOMER_PINCODE';

export const FETCH_DIAGNOSTICS_AVAILABILITY = 'FETCH_DIAGNOSTICS_AVAILABILITY';
export const FETCH_DIAGNOSTICS_AVAILABILITY_START = 'FETCH_DIAGNOSTICS_AVAILABILITY_START';
export const FETCH_DIAGNOSTICS_AVAILABILITY_SUCCESS = 'FETCH_DIAGNOSTICS_AVAILABILITY_SUCCESS';
export const FETCH_DIAGNOSTICS_AVAILABILITY_FAILURE = 'FETCH_DIAGNOSTICS_AVAILABILITY_FAILURE';

export const PLACE_REORDER = 'PLACE_REORDER';
export const PLACE_REORDER_START = 'PLACE_REORDER_START';
export const PLACE_REORDER_SUCCESS = 'PLACE_REORDER_SUCCESS';
export const PLACE_REORDER_FAILURE = 'PLACE_REORDER_FAILURE';

export const FETCH_CITY_DETAILS = 'FETCH_CITY_DETAILS';
export const FETCH_CITY_DETAILS_START = 'FETCH_CITY_DETAILS_START';
export const FETCH_CITY_DETAILS_SUCCESS = 'FETCH_CITY_DETAILS_SUCCESS';
export const FETCH_CITY_DETAILS_FAILURE = 'FETCH_CITY_DETAILS_FAILURE';

export const ADD_PATIENT = 'ADD_PATIENT';
export const ADD_PATIENT_START = 'ADD_PATIENT_START';
export const ADD_PATIENT_SUCCESS = 'ADD_PATIENT_SUCCESS';
export const ADD_PATIENT_FAILURE = 'ADD_PATIENT_FAILURE';

export const DELETE_PATIENT = 'DELETE_PATIENT';
export const DELETE_PATIENT_START = 'DELETE_PATIENT_START';
export const DELETE_PATIENT_SUCCESS = 'DELETE_PATIENT_SUCCESS';
export const DELETE_PATIENT_FAILURE = 'DELETE_PATIENT_FAILURE';

export const FETCH_PATIENTS = 'FETCH_PATIENTS';
export const FETCH_PATIENTS_START = 'FETCH_PATIENTS_START';
export const FETCH_PATIENTS_SUCCESS = 'FETCH_PATIENTS_SUCCESS';
export const FETCH_PATIENTS_FAILURE = 'FETCH_PATIENTS_FAILURE';

export const UPDATE_PATIENT = 'UPDATE_PATIENT';
export const UPDATE_PATIENT_START = 'UPDATE_PATIENT_START';
export const UPDATE_PATIENT_SUCCESS = 'UPDATE_PATIENT_SUCCESS';
export const UPDATE_PATIENT_FAILURE = 'UPDATE_PATIENT_FAILURE';

export const SET_DIAGNOSTIC_OPT_IN = 'SET_DIAGNOSTIC_OPT_IN';

export const GET_DIAGNOSTICS_SLOTS_DATE = 'GET_DIAGNOSTICS_SLOTS_DATE';
export const GET_DIAGNOSTICS_SLOTS_DATE_START = 'GET_DIAGNOSTICS_SLOTS_DATE_START';
export const GET_DIAGNOSTICS_SLOTS_DATE_SUCCESS = 'GET_DIAGNOSTICS_SLOTS_DATE_SUCCESS';
export const GET_DIAGNOSTICS_SLOTS_DATE_FAILURE = 'GET_DIAGNOSTICS_SLOTS_DATE_FAILURE';
export const RESET_TO_INITIAL_SLOT_STATE = 'RESET_TO_INITIAL_SLOT_STATE';

export const GET_DIAGNOSTICS_SLOTS_TIME = 'GET_DIAGNOSTICS_SLOTS_TIME';
export const GET_DIAGNOSTICS_SLOTS_TIME_START = 'GET_DIAGNOSTICS_SLOTS_TIME_START';
export const GET_DIAGNOSTICS_SLOTS_TIME_SUCCESS = 'GET_DIAGNOSTICS_SLOTS_TIME_SUCCESS';
export const GET_DIAGNOSTICS_SLOTS_TIME_FAILURE = 'GET_DIAGNOSTICS_SLOTS_TIME_FAILURE';

export const SET_SELECTED_SLOT = 'SET_SELECTED_SLOT';

export const SET_SELECTED_LAB = 'SET_SELECTED_LAB';

export const SET_SELECTED_GENDER = 'SET_SELECTED_GENDER';
export const GET_AVAILABLE_LAB = 'GET_AVAILABLE_LAB';
export const GET_AVAILABLE_LAB_START = 'GET_AVAILABLE_LAB_START';
export const GET_AVAILABLE_LAB_SUCCESS = 'GET_AVAILABLE_LAB_SUCCESS';
export const GET_AVAILABLE_LAB_FAILURE = 'GET_AVAILABLE_LAB_FAILURE';

export const GET_AVAILABLE_LABS_TO_CHANGE_SELECTED_LAB = 'GET_AVAILABLE_LABS_TO_CHANGE_SELECTED_LAB';
export const GET_AVAILABLE_LABS_TO_CHANGE_SELECTED_LAB_START = 'GET_AVAILABLE_LABS_TO_CHANGE_SELECTED_LAB_START';
export const GET_AVAILABLE_LABS_TO_CHANGE_SELECTED_LAB_SUCCESS = 'GET_AVAILABLE_LABS_TO_CHANGE_SELECTED_LAB_SUCCESS';
export const GET_AVAILABLE_LABS_TO_CHANGE_SELECTED_LAB_FAILURE = 'GET_AVAILABLE_LABS_TO_CHANGE_SELECTED_LAB_FAILURE';

export const CHANGE_DIAGNOSTICS_LAB = 'CHANGE_DIAGNOSTICS_LAB';
export const CHANGE_DIAGNOSTICS_LAB_START = 'CHANGE_DIAGNOSTICS_LAB_START';
export const CHANGE_DIAGNOSTICS_LAB_SUCCESS = 'CHANGE_DIAGNOSTICS_LAB_SUCCESS';
export const CHANGE_DIAGNOSTICS_LAB_FAILURE = 'CHANGE_DIAGNOSTICS_LAB_FAILURE';

export const GET_DIAGNOSTICS_CART = 'GET_DIAGNOSTICS_CART';
export const GET_DIAGNOSTICS_CART_START = 'GET_DIAGNOSTICS_CART_START';
export const GET_DIAGNOSTICS_CART_SUCCESS = 'GET_DIAGNOSTICS_CART_SUCCESS';
export const GET_DIAGNOSTICS_CART_FAILURE = 'GET_DIAGNOSTICS_CART_FAILURE';

export const DELETE_DIAGNOSTICS_ITEM = 'DELETE_DIAGNOSTICS_ITEM';
export const DELETE_DIAGNOSTICS_ITEM_START = 'DELETE_DIAGNOSTICS_ITEM_START';
export const DELETE_DIAGNOSTICS_ITEM_SUCCESS = 'DELETE_DIAGNOSTICS_ITEM_SUCCESS';
export const DELETE_DIAGNOSTICS_ITEM_FAILURE = 'DELETE_DIAGNOSTICS_ITEM_FAILURE';

export const ADD_TO_CART_DIAG = 'ADD_TO_CART_DIAG';
export const ADD_TO_CART_DIAG_START = 'ADD_TO_CART_DIAG_START';
export const ADD_TO_CART_DIAG_SUCCESS = 'ADD_TO_CART_DIAG_SUCCESS';
export const ADD_TO_CART_DIAG_FAILURE = 'ADD_TO_CART_DIAG_FAILURE';

export const PLACE_DIAGNOSTICS_ORDER = 'PLACE_DIAGNOSTICS_ORDER';
export const PLACE_DIAGNOSTICS_ORDER_START = 'PLACE_DIAGNOSTICS_ORDER_START';
export const PLACE_DIAGNOSTICS_ORDER_SUCCESS = 'PLACE_DIAGNOSTICS_ORDER_SUCCESS';
export const PLACE_DIAGNOSTICS_ORDER_FAILURE = 'PLACE_DIAGNOSTICS_ORDER_FAILURE';

export const UNIFIED_PAYMENT_FEATURE_FLAG = 'LOAD_FEATURE_FLAG';
export const UNIFIED_PAYMENT_FEATURE_FLAG_START = 'LOAD_FEATURE_FLAG_START';
export const UNIFIED_PAYMENT_FEATURE_FLAG_SUCCESS = 'LOAD_FEATURE_FLAG_SUCCESS';
export const UNIFIED_PAYMENT_FEATURE_FLAG_FAIL = 'LOAD_FEATURE_FLAG_FAIL';

export const GET_DIAGNOSTICS_ORDER_DETAILS = 'GET_DIAGNOSTICS_ORDER_DETAILS';
export const GET_DIAGNOSTICS_ORDER_DETAILS_START = 'GET_DIAGNOSTICS_ORDER_DETAILS_START';
export const GET_DIAGNOSTICS_ORDER_DETAILS_SUCCESS = 'GET_DIAGNOSTICS_ORDER_DETAILS_SUCCESS';
export const GET_DIAGNOSTICS_ORDER_DETAILS_FAILURE = 'GET_DIAGNOSTICS_ORDER_DETAILS_FAILURE';

export const GET_RECOMMENDED_ITEMS = 'GET_RECOMMENDED_ITEMS';
export const GET_RECOMMENDED_ITEMS_START = 'GET_RECOMMENDED_ITEMS_START';
export const GET_RECOMMENDED_ITEMS_SUCCESS = 'GET_RECOMMENDED_ITEMS_SUCCESS';
export const GET_RECOMMENDED_ITEMS_FAILURE = 'GET_RECOMMENDED_ITEMS_FAILURE';

export const REJECT_RECOMMENDED_ITEMS = 'REJECT_RECOMMENDED_ITEMS';
export const REJECT_RECOMMENDED_ITEMS_START = 'REJECT_RECOMMENDED_ITEMS_START';
export const REJECT_RECOMMENDED_ITEMS_SUCCESS = 'REJECT_RECOMMENDED_ITEMS_SUCCESS';
export const REJECT_RECOMMENDED_ITEMS_FAILURE = 'REJECT_RECOMMENDED_ITEMS_FAILURE';

export const SEND_OTP = 'SEND_OTP';
export const SET_PHYSICAL_REPORT_NEEDED = 'SET_PHYSICAL_REPORT_NEEDED';
export const PRODUCT_SEARCH_DIAG_CLEAR = 'PRODUCT_SEARCH_DIAG_CLEAR';

export const GET_ORDER_PLACEMENT_REASON = 'GET_ORDER_PLACEMENT_REASON';

export const FETCH_ALL_OFFER_TAGS = 'FETCH_ALL_OFFER_TAGS';
export const FETCH_ALL_OFFER_TAGS_START = 'FETCH_ALL_OFFER_TAGS_START';
export const FETCH_ALL_OFFER_TAGS_SUCCESS = 'FETCH_ALL_OFFER_TAGS_SUCCESS';
export const FETCH_ALL_OFFER_TAGS_FAILURE = 'FETCH_ALL_OFFER_TAGS_FAILURE';

export const FETCH_OFFERS = 'FETCH_OFFERS';
export const FETCH_OFFERS_START = 'FETCH_OFFERS_START';
export const FETCH_OFFERS_SUCCESS = 'FETCH_OFFERS_SUCCESS';
export const FETCH_OFFERS_FAILURE = 'FETCH_OFFERS_FAILURE';


export const RESET_DIAGNOSTICS_SELECTED_LOYALTY_VARIANT = "RESET_DIAGNOSTICS_SELECTED_LOYALTY_VARIANT";
export const SET_DIAGNOSTICS_SELECTED_LOYALTY_VARIANT = "SET_DIAGNOSTICS_SELECTED_LOYALTY_VARIANT";

export const FILE_TYPE = {
  pdf: 'application/pdf',
  image: 'image'
};

export const BIFURCATION_TYPE_CART_TOTAL = 0;
export const BIFURCATION_TYPE_TOTAL_PAYABLE = 2;
export const BIFURCATION_TYPE_DISCOUNT = 3;
export const BIFURCATION_TYPE_PROMO_DISCOUNT = 5;

export const UPLOAD_MAX_FILES = 5;
export const UPLOAD_MAX_SIZE = 10 * 1024 * 1024; // 10 MB
export const UPLOAD_ALLOWED_TYPES = ['image/jpeg', 'image/png', 'application/pdf'];

export const OrderTypeCodeMapping = {
  medicineOrder: 0,
  docConsultOrder: 2,
  otcOrder: 3,
  atcOrder: 4,
};
export const PromotionOrderTypeMapping = {
  medicineOrder: 1,
  diagnosticOrder: 2,
  otcOrder: 4,
  atcOrder: 4,
};

export const DeliveredOrderStates = [0];

export const customMedicineFalgId = 0;

export const TOTAL_PAYABLE_AMOUNT = 'total_payable_amount';

/** diagnostics cart fare breakup Enum mapping */
export const FareFieldMapping = {
  item_total: 'Cart Total',
  coupon_applied: 'Coupon Discount',
  sample_collection: 'Sample Collection Charge',
  platform_charge: 'Platform Charges',
  order_total: 'Order Total',
  pharmeasy_wallet: 'Pharmeasy Wallet',
  total_payable_amount: 'Amount to be paid',
  pharmeasy_plus: "PharmEasy Plus",
};

/** diagnostics routes Enum mapping */
export const DiagnosticsPathMapping = {
  step2_Path: '/diagnostics/add-products',
  step3_Path: '/diagnostics/select-address',
  step4_Path: '/diagnostics/review-order',
};

export const apiMap = {
  agent: {
    endpoint: '/v3/agents/login',
    method: 'post'
  },
  customer: {
    endpoint: '/v3/users/login',
    method: 'post'
  },
  sendOTP: {
    endpoint: '/v3/users/send-otp',
    method: 'post'
  },
  search: {
    endpoint: '/v3/ecommerce/search',
    method: 'get'
  },
  neighbourhood: {
    endpoint: '/v3/pincodes/search-neighbourhood',
    method: 'get',
  },
  pincode: {
    endpoint: '/v3/pincodes',
    method: 'get'
  },
  cart: {
    endpoint: '/v3/ecommerce/cart/items',
    method: 'get'
  },
  addToCart: {
    endpoint: '/v5/cart/items',
    method: 'post'
  },
  removeFromCart: {
    endpoint: '/v5/cart/items',
    method: 'delete'
  },
  updateCart: {
    endpoint: '/v5/cart/items',
    method: 'put'
  },
  cartV5: {
    endpoint: '/v5/cart',
    method: 'get'
  },
  loyalty: {
    endpoint: '/v3/loyalty/data',
    method: 'get'
  },
  activeRefills: {
    endpoint: '/v3/orders/delivery-preference',
    method: 'get'
  },
  saveNewAddress: {
    endpoint: '/v3/addresses',
    method: 'post'
  },
  editAddress: {
    endpoint: '/v3/addresses',
    method: 'put'
  },
  deleteAddress: {
    endpoint: '/v3/addresses',
    method: 'delete'
  },
  fetchAddresses: {
    endpoint: '/v3/addresses',
    method: 'get'
  },
  promoCode: {
    endpoint: '/v3/promotions',
    method: 'post'
  },
  diagnosticsPromoCode: {
    endpoint: '/api/order/v2/verify_promo_code',
    method: 'get'
  },
  createOrder: {
    endpoint: '/v3/ecommerce/orders',
    method: 'post'
  },
  notifyCustomerDTP: {
    endpoint: '/v3/ecommerce/products',
    method: 'post'
  },
  fetchActiveRefills: {
    endpoint: '/v3/subscriptions',
    method: 'get'
  },
  fetchDeliveredMedicines: {
    endpoint: '/v3/ecommerce/search/recommended',
    method: 'get'
  },
  fetchDeliveredOrders: {
    endpoint: '/v3/orders',
    method: 'get'
  },
  fetchDeliveredOrdersV5: {
    endpoint: '/v5/orders',
    method: 'get'
  },
  agentLogout: {
    endpoint: '/v3/agents/logout',
    method: 'post'
  },
  customerProfileUpdate: {
    endpoint: '/v3/customers',
    method: 'PUT'
  },
  getPaymentGateways: {
    endpoint: '/v3/payments/payment-gateways',
    method: 'get'
  },
  getPrescriptionImages: {
    endpoint: '/v3/prescriptions/prescription-upload-options',
    method: 'get'
  },
  reorder: {
    endpoint: (isNewOrderFlow) => `/${isNewOrderFlow ? 'v5' : 'v3'}/orders`,
    method: 'put'
  },
  generateS3Url: {
    endpoint: '/v3/images/generate-s3-url',
    method: 'get'
  },
  generateS3UrlV5: {
    endpoint: '/v5/images/generate-s3-url',
    method: 'get'
  },
  fetchCityDetails: {
    endpoint: '/v3/city',
    method: 'get'
  },
  diagnosticsOptIn: {
    endpoint: '/v3/customers/diagnostic/opt-in',
    method: 'post'
  },
  diagnosticsSearch: {
    endpoint: '/v1/omnisearch/view_results',
    method: 'get'
  },
  addPatient: {
    endpoint: '/v1/patients',
    method: 'post'
  },
  deletePatient: {
    endpoint: '/v1/patients',
    method: 'delete'
  },
  fetchPatients: {
    endpoint: '/v1/patients/all',
    method: 'get'
  },
  updatePatient: {
    endpoint: '/v1/patients',
    method: 'put'
  },
  diagnosticsSlotList: {
    endpoint: '/slot/v2/slot-service/slot-list/address-city',
    method: 'get',
  },
  diagnosticsSlotTime: {
    endpoint: '/slot/v2/slot-service/slot-list/slots_by_date',
    method: 'get',
  },
  diagnosticsGetCart: {
    endpoint: '/order/v5/cart',
    method: 'get',
  },
  diagnosticsDeleteItem: {
    endpoint: '/order/v2/cart/remove_from_cart',
    method: 'patch',
  },
  getAvailableLab: {
    endpoint: '/v1/labs/available_labs',
    method: 'post',
  },
  getLabs: {
    endpoint: '/v1/labs',
    method: 'get',
  },
  getLabServiceability: {
    endpoint: '/v1/labs/lab_serviceability',
    method: 'post',
  },
  atcDiag: {
    endpoint: '/order/v2/cart/add_to_cart',
    method: 'patch',
  },
  changeLab: {
    endpoint: '/order/v2/cart/change_lab',
    method: 'patch',
  },
  placeDiagOrder: {
    endpoint: '/order/v2/orders/create-order',
    method: 'post',
  },
  fetchCatalogConfig: {
    endpoint: '/lab/v2/catalog/config',
    method: 'get',
  },
  diagOrderDetails: {
    endpoint: '/order/v2/orders',
    method: 'get'
  },
  closeLead: {
    endpoint: '/v3/diagnostic-leads',
    method: 'put',
  },
  closeDxLead: {
    endpoint: '/leads-service/v1/lead/order',
    method: 'PATCH',
  },
  getOrderPlacementReasons: {
    endpoint: '/v3/ecommerce/orders/placement-reasons',
    method: 'get'
  },
  getProductAlternates: {
    endpoint: '/v3/substitution/substitutes-and-variants',
    method: 'get'
  },
  getSimilarProducts: {
    endpoint: '/v3/substitution/similar-products',
    method: 'get'
  },
  addSubstitutionRecord: {
    endpoint: '/v3/substitution/substituted-cart-items',
    method: 'post'
  },
  fetchSubstitutedCartItems: {
    endpoint: '/v3/substitution/substituted-cart-items',
    method: 'get'
  },
  addSubstitutionEventLog: {
    endpoint: '/v3/substitution/log-event',
    method: 'post'
  },
  getSubstitutionReasons: {
    endpoint: '/v3/substitution/reasons',
    method: 'get'
  },
  postSubstitutionReasons: {
    endpoint: '/v3/substitution/reasons',
    method: 'post'
  },
  fetchPaymentMethods: {
    endpoint: '/v3/ecommerce/payment-instrument',
    method: 'get'
  },
  fetchPaymentMethodsV5: {
    endpoint: '/v5/payment-instrument/pay-modes',
    method: 'post'
  },
  fetchWalletDetails: {
    endpoint: '/v3/wallet',
    method: 'get'
  },
  setSessionOrderMap: {
    endpoint: '/v3/orders/session',
    method: 'post'
  },
  getRecommendedItems: {
    endpoint: '/v3/agent-suggestor/recommendations',
    method: 'get'
  },
  rejectRecommendedItem: {
    endpoint: '/v3/agent-suggestor/reject',
    method: 'put'
  },
  postValidationOnSameOrder: {
    endpoint: '/v1/cart/review',
    method: 'post',
  },
  deliveryPreferences: {
    endpoint: '/v5/delivery-preferences',
    method: 'get'
  },
  cartAmountBifurcation: {
    endpoint: '/v5/cart/view-amount-bifurcation',
    method: 'post'
  },
  placeOrderV5: {
    endpoint: '/v5/orders',
    method: 'post'
  },
  parentOrderDetails: {
    endpoint: id => `/v5/orders/${id}/parent`,
    method: 'get'
  },
  fetchAllOfferTags: {
    endpoint: '/v3/offers/all-offer-tags',
    method: 'get'
  },
  fetchOffers: {
    endpoint: '/v3/promotions/offers?offertags=offers_ooc',
    method: 'get'
  },
  postPincodeServiceability: {
    endpoint: '/v1/serviceability/pincodes',
    method: 'post',
  },
  fetchSpecialities: {
    endpoint: '/service/api/v1/concerns',
    method: 'get',
  },
  fetchDoctors: {
    endpoint: '/service/api/v1/doctors',
    method: 'get',
  },
  fetchDocConsultSlots: {
    endpoint: '/service/api/v1/slots',
    method: 'get',
  },
  fetchDocConsultBifurcation: {
    endpoint: '/service/v1/cart/view-amount-bifurcation',
    method: 'post',
  },
  createDocConsultOrder: {
    endpoint: '/service/v1/consult-orders',
    method: 'post',
  },
  // Service-Platform API Endpoints
  fetchCategoriesSubCategories: {
    endpoint: '/service-platform/catalog/v1/services',
    method: 'get',
  },
  fetchServiceItemDetails: {
    endpoint: '/service-platform/catalog/v1/items',
    method: 'get',
  },
  fetchServicePackages: {
    endpoint: '/service-platform/catalog/v1/items',
    method: 'get',
  },
  fetchServiceItemVariants: {
    endpoint: '/service-platform/catalog/v1/items',
    method: 'get',
  },
  fetchServiceSlots: {
    endpoint: '/service-platform/catalog/v1/slots',
    method: 'get',
  },
  fetchServiceBifurcation: {
    endpoint: '/service/v1/cart/view-amount-bifurcation',
    method: 'post',
  },
  createServiceOrder: {
    endpoint: '/service/v1/service/orders',
    method: 'post',
  },
};
